import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { API_URL } from '../utils/api';

const PartnerRequests = ({ open, onClose, onRequestHandled }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/partner-requests`);
      setRequests(response.data);
    } catch (error) {
      console.error('Error fetching partner requests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchRequests();
    }
  }, [open]);

  const handleAccept = async (userId) => {
    try {
      await axios.post(`${API_URL}/api/users/accept-partner/${userId}`);
      setRequests(requests.filter(request => request._id !== userId));
      if (onRequestHandled) onRequestHandled();
    } catch (error) {
      console.error('Error accepting partner request:', error);
    }
  };

  const handleReject = async (userId) => {
    try {
      await axios.post(`${API_URL}/api/users/reject-partner/${userId}`);
      setRequests(requests.filter(request => request._id !== userId));
    } catch (error) {
      console.error('Error rejecting partner request:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Partner Requests
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography>Loading requests...</Typography>
        ) : requests.length === 0 ? (
          <Typography>No pending partner requests</Typography>
        ) : (
          <List>
            {requests.map((request) => (
              <ListItem
                key={request._id}
                sx={{
                  border: '1px solid rgba(0,0,0,0.04)',
                  borderRadius: 'var(--radius-sm)',
                  mb: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(123,97,255,0.03)',
                  },
                }}
              >
                <ListItemAvatar>
                  <Avatar src={request.avatar} alt={request.firstName}>
                    {request.firstName?.charAt(0)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={`${request.firstName} ${request.lastName}`}
                  secondary="wants to be your partner"
                />
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleAccept(request._id)}
                    sx={{
                      mr: 1,
                      background: 'linear-gradient(90deg,var(--gradient-start),var(--gradient-end))',
                      boxShadow: 'var(--elevation-2)',
                      color: 'white',
                      '&:hover': { transform: 'translateY(-2px)', filter: 'brightness(0.98)' },
                    }}
                  >
                    Accept
                  </Button>
                  <Button
                    variant="outlined"
                    color="inherit"
                    sx={{ borderColor: 'rgba(123,97,255,0.12)', color: 'var(--muted)' }}
                    onClick={() => handleReject(request._id)}
                  >
                    Reject
                  </Button>
                </Box>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PartnerRequests; 